module.exports = __webpack_public_path__ + "img/V-R-6-unload-connect.15060448.png";